/**
 * 底圖破圖自動重試（逾時／502／暫時失敗後再抓，不換底圖）
 */

export const TILE_RETRY_MAX = 4;
export const TILE_RETRY_BASE_MS = 500;

export function shouldRetryTile(attempt, max = TILE_RETRY_MAX) {
    return Number(attempt) >= 0 && Number(attempt) < max;
}

export function nextTileRetryDelayMs(attempt, baseMs = TILE_RETRY_BASE_MS) {
    const n = Math.max(0, Number(attempt) || 0);
    return baseMs * 2 ** n;
}

/** 不可用 query `r`：Carto 代理把 r 當 @2x 後綴 */
export function withRetryQuery(url, attempt) {
    const raw = String(url || '');
    const hash = raw.indexOf('#');
    const noHash = hash >= 0 ? raw.slice(0, hash) : raw;
    const q = noHash.indexOf('?');
    const path = q >= 0 ? noHash.slice(0, q) : noHash;
    const params = new URLSearchParams(q >= 0 ? noHash.slice(q + 1) : '');
    params.delete('r');
    params.set('_retry', String(attempt));
    const search = params.toString();
    return search ? `${path}?${search}` : path;
}

export function isBrokenTileImage(el) {
    if (!el || el.tagName !== 'IMG') return false;
    if (!el.complete) return false;
    return el.naturalWidth === 0;
}

function scheduleTileSrc(tile, src, delayMs) {
    clearTimeout(tile._sovereignRetryTimer);
    tile._sovereignRetryTimer = setTimeout(() => {
        if (!tile.isConnected) return;
        tile.src = src;
    }, delayMs);
}

function retryTileEl(layer, coords, tile, reason) {
    if (!layer || !tile || !coords) return;
    const attempt = tile._sovereignRetry || 0;
    if (!shouldRetryTile(attempt)) return;
    tile._sovereignRetry = attempt + 1;
    const url = typeof layer.getTileUrl === 'function' ? layer.getTileUrl(coords) : tile.src;
    const src = withRetryQuery(url, tile._sovereignRetry);
    scheduleTileSrc(tile, src, nextTileRetryDelayMs(attempt));
    if (attempt === 0) {
        console.warn(`[SOVEREIGN-MAP] 圖磚失敗，自動重試 (${reason})`);
    }
}

export function reloadBrokenTiles(layer) {
    if (!layer?._tiles) return 0;
    let n = 0;
    for (const rec of Object.values(layer._tiles)) {
        const el = rec?.el;
        const coords = rec?.coords;
        if (!isBrokenTileImage(el)) continue;
        retryTileEl(layer, coords, el, 'scan');
        n += 1;
    }
    return n;
}

export function attachTileAutoReload(layer, map) {
    if (!layer) return;
    layer.on('tileerror', (e) => {
        retryTileEl(layer, e.coords, e.tile, 'tileerror');
    });
    if (!map) return;
    const scan = () => reloadBrokenTiles(layer);
    map.on('moveend', scan);
    map.on('zoomend', scan);
    window.addEventListener('online', scan);
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') scan();
    });
}
